'use client';

import { usePathname } from 'next/navigation';
import './styles/@theme';
import './styles/default.scss';
import { useState, useEffect } from 'react';
import { useStore } from '@/store/store';
import { classes } from '@/utils/classes/classes';
import { SearchDrawer } from '@/app/components/search-drawer/subcomponents/search-drawer-client/search-drawer.client';
import { SearchProvider } from '@/app/components/search-drawer/subcomponents/context';
import { RecommendedGames } from './subcomponents/recommended-games/recommended-games';

export const SearchDrawerContainer: React.FC = () => {
    const search = useStore((s) => s.search);
    const closeSearch = useStore((s) => s.search.closeSearch);
    const pathname = usePathname();

    useEffect(() => {
        closeSearch();
    }, [pathname, closeSearch]);

    const [topPosition, setTopPosition] = useState(0);

    useEffect(() => {
        const [header] = document.getElementsByTagName('header');
        if (!header) {
            return;
        }

        const headerContent = header.getElementsByClassName('header-content')[0];
        const headerFixed = header.getElementsByClassName('header-fixed')[0];

        if (!(headerContent instanceof HTMLElement) || !(headerFixed instanceof HTMLElement)) {
            return;
        }

        let topValue = 0;

        if (document.body.scrollTop === 0) {
            topValue = header.clientHeight;
        } else if (document.body.scrollTop <= headerContent.clientHeight) {
            topValue = header.clientHeight;
        } else {
            topValue = headerFixed.clientHeight + document.body.scrollTop;
        }

        setTopPosition(topValue);
    }, [search.isSearchOpen]);

    return (
        <div
            data-testid="container"
            className={classes('search-drawer-container', search.isSearchOpen && 'open')}
            style={{ top: topPosition }}>
            <button data-testid="overlay" className="overlay" onClick={search.toggleIsSearchOpen}></button>
            <SearchProvider>
                <SearchDrawer>
                    <RecommendedGames />
                </SearchDrawer>
            </SearchProvider>
        </div>
    );
};
